<!-- src/components/DashboardCard.vue -->
<template>
  <div class="kpi-card" outlined :style="{backgroundColor:color}">
    <div class="kpi-header">
      <!-- Título à esquerda -->
       <div class="kpi-title-container">
         <div class="kpi-title">
           {{ title }}
         </div>
         <div class="kpi-subtitle">
           {{ subtitle }}
         </div>
       </div>
      
      <!-- Ícone à direita do container -->
      <div
        size="40"
        class="elevation-1 d-flex justify-center align-center"
        :style="{ 
          backgroundColor: iconBgColor, 
          width: '40px', 
          height: '40px', 
          borderRadius: '10px' 
        }"
        v-if="iconBG"
      >
        <img v-if="iconType === 'image'" :src="icon" height="24" width="24" alt="icon" />
        <v-icon v-else :style="{ color: iconColor }">
          {{ icon }}
        </v-icon>
      </div>
      <div v-if="!iconBG">
        <img v-if="iconType === 'image'" :src="icon" height="24" width="24" alt="icon" />
        <v-icon v-else :style="{ color: iconColor }">
          {{ icon }}
        </v-icon>
      </div>
    </div>
    
    <div style="width: 100%;">
      <slot name="value"></slot>
    </div>

    <div v-if="$slots.footer" class="mt-4">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { colors } from 'vuetify/lib';


export default {
  name: 'DashboardCard',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    iconBG: {
      type: Boolean,
      required: false
    },
    icon: {
      type: String,
      required: true
    },
    iconType: {
      type: String,
      default: 'material',
      validator: value => ['material', 'image'].includes(value)
    },
    // Cor do texto do título
    titleColor: {
      type: String,
      default: '#63A9FF'
    },
    // Cor do ícone em si
    iconColor: {
      type: String,
      default: '#63A9FF'
    },
    // Cor do fundo do círculo do ícone
    iconBgColor: {
      type: String,
      default: 'rgba(99, 169, 255, 0.1)'
    },
    color:{
      type:String,
      default:'#ffffff'
    }
  }
}
</script>

<style>
.kpi-card {
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #DBDBDB;
  background: #FFF;
}

.kpi-header{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.kpi-title-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  min-height: 40px;
}

.kpi-title {
  color: #1C1C1C;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.kpi-subtitle {
  color: #545454;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
